import server from "./server";
import toaster from "./toaster";

function handleRejectWithToaster(err) {
  console.log(err.response);
  toaster.fail({
    txt: !!err.response.data.errors
      ? Object.values(err.response.data.errors).map(errLst => errLst.join(" "))
      : err.response.data.message
  });
  throw err;
}

export default {
  getFeedback(courseId, lang) {
    return server
      .get("api/public/company/feedback/" + courseId + "?lang_id=" + lang)
      .then(r => r.data);
  },
  getRelationTypes(courseId) {
    return server.get("api/public/feedback/roles/" + courseId).then(r => r.data);
  },
  getAllRelations(courseId) {
    return server
      .get("api/public/feedback/getAllRelations/" + courseId)
      .then(x => {
        return x.data;
      });
  },
  postAddRelation(courseId, evaluatedId, evaluatingId, roleId) {
    return server
      .post("api/public/feedback/relations/addRelation", {
        course_id: courseId,
        evaluated_id: evaluatedId,
        evaluating_id: evaluatingId,
        role_id: roleId
      })
      .then(x => {
        console.log(x);
        return x;
      }, handleRejectWithToaster);
  },
  postEditParticipant({
    customerId,
    uid,
    email,
    firstName,
    lastName,
    courseId
  }) {
    const dto = { customerId, uid, email, firstName, lastName, courseId };
    return server.post("api/public/feedback/editParticipant", dto).then(r => {
      if (r.data.ok) {
        toaster.success({ txt: "Účastník uložený." });
      }
      return r;
    }, handleRejectWithToaster);
  },

  postDeleteParticipantLink({ participationId, courseId }) {
    const dto = { participationId, courseId };
    return server.post("api/public/feedback/delParticipant", dto).then(r => {
      if (r.data.ok) {
        toaster.success({ txt: "Účastník zmazaný." });
      }
      return r;
    }, handleRejectWithToaster);
  },

  postSaveRelationsForm(dto) {
    /*
    dto = {
      courseId: 1,
      formData: [
          {evaluatedId, relations: [{relationId, roleId, evaluatedId, evaluatingId}], deleted: [relation_id_of_deleted,...]}
        ]
      }

    */
    return server.post("api/public/feedback/relationsForm", dto).then(r => {
      if (r.data.ok) {
        toaster.success({ txt: "Uložené." });
      }
      return r;
    }, handleRejectWithToaster);
  }
};



// WEBPACK FOOTER //
// ./src/public_app/api/feedback.js